module.exports = new __parcel__URL__("objectives_bg.c54dac1e.png").toString();